module.exports = __webpack_public_path__ + "img/choose-img_ja.4abd89e4.png";